import type { NavItemNavigationOptions } from '../types';

export const getRedirectionProps = (openInNewTab?: boolean) => {
  return { underline: 'none' as const, ...(openInNewTab && { target: '_blank' }) };
};

/** Prefers `navigationOptions.openInNewTab`; falls back to deprecated top-level `openInNewTab`. */
export function resolveOpenInNewTab(item: {
  navigationOptions?: NavItemNavigationOptions;
  openInNewTab?: boolean;
}): boolean | undefined {
  return item.navigationOptions?.openInNewTab ?? item.openInNewTab;
}
